export interface MovieItem {
  id: string;
  title: string;
  category: string;
  subcategory: string;
  year: number;
  rating: number;
  imageUrl: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  region: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  episodes?: number;
  updateStatus?: string;
}

export const categories: { slug: string; name: string; icon: string }[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-film-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'dongman', name: '动漫', icon: 'ri-rocket-line' },
];

export const movies: MovieItem[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    category: 'dianying',
    subcategory: '科幻',
    year: 2026,
    rating: 8.7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20and%20glowing%20planet%20earth%2C%20dramatic%20cinematic%20lighting%2C%20dark%20space%20background%20with%20stars%2C%20warm%20orange%20and%20blue%20highlights%2C%20epic%20movie%20poster%20style%2C%20professional%20film%20photography&width=600&height=840&seq=movie-liulangdiqiu-3&orientation=portrait',
    description: '在太阳急速衰老膨胀的未来，人类面临前所未有的生存危机。《流浪地球3》延续前作的故事线，讲述人类在漫长的宇宙流浪旅程中遭遇全新挑战，为了拯救地球和人类文明，一群勇敢的宇航员再次踏上充满未知的冒险之旅。宏大震撼的视觉特效，感人至深的家国情怀，将中国科幻电影推向新的高度。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '148分钟',
    region: '中国大陆',
    tags: ['科幻', '冒险', '灾难', '热门'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-2',
    title: '长津湖之水门桥',
    category: 'dianying',
    subcategory: '战争',
    year: 2025,
    rating: 9.1,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20war%20film%20poster%20with%20soldiers%20in%20snowy%20battlefield%2C%20dramatic%20winter%20mountain%20landscape%2C%20cinematic%20lighting%20with%20warm%20golden%20tones%2C%20heroic%20atmosphere%2C%20professional%20movie%20poster%20photography%2C%20misty%20cold%20atmosphere&width=600&height=840&seq=movie-changjinhu-2&orientation=portrait',
    description: '以抗美援朝战争第二次战役中的长津湖战役为背景，讲述了在结束了新兴里和下碣隅里的战斗之后，七连战士们又接到了更艰巨的任务。在零下四十度的极寒天气中，志愿军战士们以钢铁般的意志奋勇作战，誓死守卫水门桥。',
    director: '陈凯歌、徐克、林超贤',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    duration: '149分钟',
    region: '中国大陆',
    tags: ['战争', '历史', '动作', '热门'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-3',
    title: '哪吒之魔童闹海',
    category: 'dianying',
    subcategory: '动画',
    year: 2025,
    rating: 9.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%20featuring%20mythological%20warrior%20boy%20with%20fire%20and%20lightning%20effects%2C%20vibrant%20red%20and%20gold%20color%20palette%2C%20epic%20cinematic%20composition%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%203D%20animation%2C%20dramatic%20clouds%20and%20dynamic%20action&width=600&height=840&seq=movie-nezha-2&orientation=portrait',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身很快会魂飞魄散。太乙真人打算用七色宝莲给二人重塑肉身，却遭遇重重困难。哪吒与敖丙的命运将走向何方？一场关于成长、友情和勇气的神话史诗拉开序幕。',
    director: '饺子',
    actors: ['吕艳婷', '陈浩', '囧森瑟夫'],
    duration: '144分钟',
    region: '中国大陆',
    tags: ['动画', '奇幻', '冒险', '热门'],
    isHot: true,
    isNew: false,
  },
  {
    id: 'movie-4',
    title: '封神第二部：战火西岐',
    category: 'dianying',
    subcategory: '奇幻',
    year: 2025,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20poster%20with%20ancient%20warriors%20and%20mythical%20creatures%2C%20dramatic%20battle%20scene%2C%20golden%20and%20crimson%20color%20tones%2C%20traditional%20Chinese%20aesthetics%2C%20cinematic%20epic%20scale%2C%20professional%20film%20poster%20photography&width=600&height=840&seq=movie-fengshen-2&orientation=portrait',
    description: '殷商大军兵临西岐，姜子牙率众神迎战。姬发在战火中逐渐成长为真正的天下共主，而殷寿的野心也将整个商王朝推向深渊。惊天动地的神魔大战一触即发，封神世界的终极对决即将上演。',
    director: '乌尔善',
    actors: ['费翔', '黄渤', '于适', '李雪健'],
    duration: '155分钟',
    region: '中国大陆',
    tags: ['奇幻', '动作', '神话', '热门'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-5',
    title: '热辣滚烫',
    category: 'dianying',
    subcategory: '喜剧',
    year: 2024,
    rating: 8.2,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy-drama%20film%20poster%20with%20a%20confident%20woman%20in%20boxing%20gloves%2C%20warm%20empowering%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20inspirational%20tone%2C%20modern%20urban%20backdrop%2C%20professional%20movie%20poster%20style&width=600&height=840&seq=movie-relaguntang&orientation=portrait',
    description: '善良的乐莹选择脱离社会，宅家多年。在经历一系列挫折后，她决定换一种方式生活。在与外界小心翼翼的接触中，乐莹结识了拳击教练昊坤。本以为生活会就此出现转机，但各种考验接踵而至，滚烫的人生才刚刚开始。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫'],
    duration: '129分钟',
    region: '中国大陆',
    tags: ['喜剧', '剧情', '励志'],
    isHot: false,
    isNew: false,
  },
  {
    id: 'movie-6',
    title: '速度与激情11',
    category: 'dianying',
    subcategory: '动作',
    year: 2026,
    rating: 7.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=High-octane%20action%20film%20poster%20with%20fast%20sports%20cars%20racing%20through%20city%20streets%2C%20explosive%20cinematic%20lighting%2C%20dynamic%20motion%20blur%20effects%2C%20urban%20night%20setting%20with%20neon%20reflections%2C%20Hollywood%20blockbuster%20style%2C%20intense%20dramatic%20atmosphere&width=600&height=840&seq=movie-fast11&orientation=portrait',
    description: '多米尼克·托雷托和他的家人们面对有史以来最致命的敌人。从洛杉矶到伦敦，从巴西到南极，这场全球追逐将车技与智慧发挥到极致。速度与激情系列的全新篇章，肾上腺素飙升的视听盛宴。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹'],
    duration: '141分钟',
    region: '美国',
    tags: ['动作', '冒险', '犯罪'],
    isHot: true,
    isNew: true,
  },
  {
    id: 'movie-7',
    title: '第二十条',
    category: 'dianying',
    subcategory: '剧情',
    year: 2024,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20legal%20drama%20film%20poster%20with%20courtroom%20setting%2C%20solemn%20atmosphere%2C%20warm%20cinematic%20lighting%2C%20humanistic%20drama%20tone%2C%20professional%20movie%20poster%20style%2C%20emotional%20depth%2C%20realistic%20Chinese%20social%20drama&width=600&height=840&seq=movie-diershitiao&orientation=portrait',
    description: '以真实法律案件为蓝本，讲述检察官韩明在处理一起看似普通的案件中，发现了隐藏在背后的深层社会问题。法律与人情的碰撞，正义与现实的博弈，一部发人深省的现实主义力作。',
    director: '张艺谋',
    actors: ['雷佳音', '马丽', '赵丽颖', '高叶'],
    duration: '135分钟',
    region: '中国大陆',
    tags: ['剧情', '法律', '社会'],
    isHot: false,
    isNew: true,
  },
  {
    id: 'tv-1',
    title: '庆余年第二季',
    category: 'dianshiju',
    subcategory: '古装',
    year: 2025,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20TV%20series%20poster%20with%20ancient%20Chinese%20palace%20and%20scholarly%20figure%2C%20elegant%20traditional%20costumes%2C%20warm%20golden%20cinematic%20lighting%2C%20palace%20intrigue%20atmosphere%2C%20professional%20drama%20poster%20style%2C%20misty%20classical%20Chinese%20aesthetic&width=600&height=840&seq=tv-qingyunian-2&orientation=portrait',
    description: '范闲在经历了生死考验后，继续在庆国朝堂上步步为营。权力斗争的漩涡中，他逐渐揭开母亲叶轻眉死亡背后的惊天秘密。江湖之远与庙堂之高，忠诚与背叛，爱情与牺牲，波澜壮阔的史诗故事继续展开。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚'],
    duration: '45分钟/集',
    region: '中国大陆',
    tags: ['古装', '权谋', '剧情', '热门'],
    isHot: true,
    isNew: true,
    episodes: 36,
    updateStatus: '已完结',
  },
  {
    id: 'tv-2',
    title: '繁花',
    category: 'dianshiju',
    subcategory: '都市',
    year: 2024,
    rating: 8.8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20urban%20drama%20TV%20series%20poster%20set%20in%201990s%20Shanghai%2C%20nostalgic%20golden%20era%20aesthetic%2C%20elegant%20cheongsam%20and%20suits%2C%20warm%20vintage%20cinematic%20lighting%2C%20prosperous%20city%20backdrop%2C%20Wong%20Kar-wai%20visual%20style&width=600&height=840&seq=tv-fanhua&orientation=portrait',
    description: '九十年代的上海，处处是机遇和挑战。阿宝凭借自己的智慧和勇气，在改革开放的大潮中成为商界后起之秀。黄河路上人来人往，每个人都有说不完的故事。霓虹闪烁的上海滩，上演着一幕幕悲欢离合的人生大戏。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    duration: '45分钟/集',
    region: '中国大陆',
    tags: ['都市', '商战', '爱情', '热门'],
    isHot: true,
    isNew: false,
    episodes: 30,
    updateStatus: '已完结',
  },
  {
    id: 'tv-3',
    title: '长相思',
    category: 'dianshiju',
    subcategory: '古装',
    year: 2024,
    rating: 8.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20ancient%20Chinese%20goddess-like%20figures%2C%20ethereal%20flowing%20robes%2C%20dreamy%20pastel%20celestial%20background%2C%20soft%20romantic%20cinematic%20lighting%2C%20traditional%20Chinese%20mythological%20aesthetic%2C%20elegant%20composition&width=600&height=840&seq=tv-zhangxiangsi&orientation=portrait',
    description: '上古时期，人、神、妖混居。流落大荒的高辛王姬玖瑶历经百年颠沛流离，失去了容貌和身份。在清水镇，她化名玟小六，悬壶济世为生。与玱玹、涂山璟、相柳等人的命运纠缠，一段荡气回肠的旷世情缘就此展开。',
    director: '秦榛',
    actors: ['杨紫', '张晚意', '邓为', '檀健次'],
    duration: '45分钟/集',
    region: '中国大陆',
    tags: ['古装', '爱情', '奇幻'],
    isHot: false,
    isNew: false,
    episodes: 39,
    updateStatus: '已完结',
  },
  {
    id: 'tv-4',
    title: '三体',
    category: 'dianshiju',
    subcategory: '科幻',
    year: 2024,
    rating: 8.4,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%20with%20mysterious%20cosmic%20phenomenon%20and%20three%20suns%2C%20dark%20space%20atmosphere%2C%20futuristic%20technology%20elements%2C%20dramatic%20cinematic%20lighting%2C%20intellectual%20thriller%20tone%2C%20professional%20drama%20poster%20style&width=600&height=840&seq=tv-santi&orientation=portrait',
    description: '2007年，地球基础科学出现了异常的扰动。纳米科学家汪淼进入神秘的网络游戏《三体》，开始逐步逼近这个世界的真相。与此同时，警察史强也在调查一系列科学家自杀事件。两个文明之间的生死搏杀，就此拉开帷幕。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    duration: '45分钟/集',
    region: '中国大陆',
    tags: ['科幻', '悬疑', '剧情'],
    isHot: false,
    isNew: false,
    episodes: 30,
    updateStatus: '已完结',
  },
  {
    id: 'tv-5',
    title: '狂飙',
    category: 'dianshiju',
    subcategory: '刑侦',
    year: 2023,
    rating: 9.5,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20poster%20with%20intense%20police%20and%20underworld%20confrontation%2C%20dark%20noir%20cinematic%20lighting%2C%20urban%20Chinese%20city%20backdrop%2C%20dramatic%20tension%2C%20professional%20TV%20drama%20poster%2C%20gritty%20realistic%20style&width=600&height=840&seq=tv-kuangbiao&orientation=portrait',
    description: '横跨二十年的正邪较量。一线刑警安欣在与黑恶势力的斗争中屡遭挫折，但他始终没有放弃。随着全国政法队伍教育整顿工作的开展，临江省派出指导组入驻京海，一场扫黑除恶的狂飙行动就此拉开大幕。',
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    duration: '45分钟/集',
    region: '中国大陆',
    tags: ['刑侦', '犯罪', '剧情', '热门'],
    isHot: true,
    isNew: false,
    episodes: 39,
    updateStatus: '已完结',
  },
  {
    id: 'variety-1',
    title: '奔跑吧·生态篇',
    category: 'zongyi',
    subcategory: '真人秀',
    year: 2025,
    rating: 8.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%20with%20celebrity%20cast%20running%20in%20nature%2C%20bright%20sunny%20outdoor%20setting%2C%20energetic%20playful%20atmosphere%2C%20vibrant%20green%20landscape%2C%20professional%20entertainment%20show%20poster%2C%20dynamic%20group%20photo%20style&width=600&height=840&seq=variety-benpaoba&orientation=portrait',
    description: '全新一季《奔跑吧》以"生态文明"为主题，嘉宾们将走进中国最美的自然保护区和生态景区，在绿水青山之间展开趣味横生的游戏挑战。传递环保理念的同时，为观众带来欢笑与感动。',
    director: '姚译添',
    actors: ['李晨', '郑恺', '杨颖', '白鹿'],
    duration: '90分钟/期',
    region: '中国大陆',
    tags: ['真人秀', '搞笑', '户外'],
    isHot: true,
    isNew: true,
    episodes: 12,
    updateStatus: '更新至第8期',
  },
  {
    id: 'variety-2',
    title: '歌手2025',
    category: 'zongyi',
    subcategory: '音乐',
    year: 2025,
    rating: 8.3,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20singing%20competition%20show%20poster%20with%20stage%20spotlight%20and%20microphone%2C%20dramatic%20stage%20lighting%20effects%2C%20elegant%20music%20performance%20atmosphere%2C%20professional%20entertainment%20poster%2C%20dark%20background%20with%20golden%20light%2C%20premium%20show%20visual&width=600&height=840&seq=variety-geshou2025&orientation=portrait',
    description: '华语乐坛顶级歌手巅峰对决！全新赛制升级，国内外顶尖音乐人同台竞技。每一场都是视听盛宴，每一首歌都是灵魂共鸣。谁将成为年度歌王？让我们拭目以待。',
    director: '洪涛',
    actors: ['那英', '汪峰', '周深', '张杰'],
    duration: '120分钟/期',
    region: '中国大陆',
    tags: ['音乐', '竞技', '真人秀', '热门'],
    isHot: true,
    isNew: false,
    episodes: 12,
    updateStatus: '更新至第10期',
  },
  {
    id: 'anime-1',
    title: '斗罗大陆2：绝世唐门',
    category: 'dongman',
    subcategory: '热血',
    year: 2025,
    rating: 8.9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20poster%20with%20fantasy%20martial%20arts%20characters%2C%20magical%20glowing%20spirit%20rings%2C%20epic%20battle%20stance%2C%20vibrant%20anime%20art%20style%2C%20dynamic%20action%20pose%2C%20fantasy%20world%20background%2C%20professional%20anime%20key%20visual&width=600&height=840&seq=anime-douluo-2&orientation=portrait',
    description: '故事承接《斗罗大陆》第一部，讲述霍雨浩在日月帝国的传奇冒险。背负着仇恨与使命的少年，在史莱克学院遇到了改变他一生的伙伴们。全新的魂导器体系，更加宏大的世界观，少年们将书写属于自己的传奇。',
    director: '沈乐平',
    actors: ['梁达伟', '唐雅菁', '孙晔'],
    duration: '20分钟/集',
    region: '中国大陆',
    tags: ['热血', '奇幻', '战斗', '热门'],
    isHot: true,
    isNew: true,
    episodes: 52,
    updateStatus: '更新至第40集',
  },
  {
    id: 'anime-2',
    title: '凡人修仙传·星海飞驰篇',
    category: 'dongman',
    subcategory: '仙侠',
    year: 2025,
    rating: 9.0,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20cultivation%20anime%20poster%20with%20immortal%20warrior%20flying%20through%20starry%20sky%2C%20flowing%20traditional%20robes%2C%20magical%20spirit%20energy%20effects%2C%20cosmic%20celestial%20background%2C%20elegant%20Chinese%20ink%20painting%20style%2C%20epic%20fantasy%20atmosphere&width=600&height=840&seq=anime-fanren-xiu&orientation=portrait',
    description: '韩立结丹成功后踏上星海之旅，前往乱星海寻找进阶元婴的机缘。在这片危机四伏的海域，各方势力错综复杂，远古秘境暗藏杀机。一个凡人如何在这仙魔乱世中走出自己的修仙之路？',
    director: '王裕仁',
    actors: ['钱文青', '李诗萌', '刘琮'],
    duration: '22分钟/集',
    region: '中国大陆',
    tags: ['仙侠', '冒险', '战斗', '热门'],
    isHot: true,
    isNew: false,
    episodes: 78,
    updateStatus: '更新至第65集',
  },
  {
    id: 'anime-3',
    title: '完美世界',
    category: 'dongman',
    subcategory: '热血',
    year: 2025,
    rating: 8.6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20poster%20with%20young%20warrior%20in%20ancient%20battlefield%2C%20glowing%20rune%20symbols%2C%20epic%20mythical%20beasts%2C%20dramatic%20cinematic%20lighting%2C%20traditional%20Chinese%20mythology%20elements%2C%20dynamic%20action%20scene%2C%20professional%20anime%20visual&width=600&height=840&seq=anime-wanmeishijie&orientation=portrait',
    description: '石昊在大荒中历经万难，从一个天资被夺的废柴少年逐步成长为独断万古的荒天帝。九天十地、异域战场、界海彼岸，一个个宏大世界在眼前展开。至尊骨重生，完美世界等我来开创！',
    director: '汪成果',
    actors: ['锦鲤', '赵路', '刘北辰'],
    duration: '20分钟/集',
    region: '中国大陆',
    tags: ['热血', '奇幻', '战斗'],
    isHot: false,
    isNew: false,
    episodes: 182,
    updateStatus: '更新至第170集',
  },
];

export const heroSlides = [
  {
    id: 'hero-1',
    title: '流浪地球3',
    subtitle: '太阳危机再度来袭，人类命运何去何从',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20landscape%20with%20giant%20planet%20engines%20on%20frozen%20earth%2C%20dramatic%20space%20atmosphere%2C%20warm%20orange%20glow%20against%20cold%20blue%20ice%2C%20massive%20scale%2C%20movie%20hero%20banner%20background%2C%20cinematic%20lighting%2C%20emotional%20grandeur&width=1920&height=800&seq=hero-liulang-3&orientation=landscape',
    link: '/article/movie-1',
    tag: '热播大片',
  },
  {
    id: 'hero-2',
    title: '庆余年第二季',
    subtitle: '庙堂权谋风云再起，范闲归来续写传奇',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20palace%20drama%20cinematic%20landscape%20with%20ancient%20Chinese%20architecture%2C%20golden%20hour%20lighting%20over%20imperial%20city%2C%20misty%20atmosphere%2C%20epic%20scale%2C%20hero%20banner%20background%2C%20dramatic%20cinematic%20mood%2C%20elegant%20traditional%20aesthetics&width=1920&height=800&seq=hero-qingyunian-2&orientation=landscape',
    link: '/article/tv-1',
    tag: '爆款剧集',
  },
  {
    id: 'hero-3',
    title: '哪吒之魔童闹海',
    subtitle: '我命由我不由天，魔童归来燃爆今夏',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20animation%20cinematic%20landscape%20with%20fire%20and%20lightning%20in%20stormy%20sky%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20dynamic%20energy%2C%20hero%20banner%20background%2C%20cinematic%20scale%2C%20mythical%20atmosphere%2C%20powerful%20visual%20impact&width=1920&height=800&seq=hero-nezha-2&orientation=landscape',
    link: '/article/movie-3',
    tag: '票房冠军',
  },
];

export const featureLists = {
  hot: ['movie-1', 'movie-2', 'movie-3', 'movie-4', 'movie-6', 'tv-1', 'tv-5', 'variety-1', 'anime-1', 'anime-2'],
  new: ['movie-1', 'movie-4', 'movie-6', 'movie-7', 'tv-1', 'variety-1', 'anime-1'],
};